module.exports = __webpack_public_path__ + "static/index/img/baikal-107.38356fa9.jpg";